import styled from 'styled-components'

import { pxToRems, setToLayer } from '@awaze/design-system.utils.react'

export const StyledMapContainer = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  ${setToLayer('foreground')}
  background-color: ${({ theme }) => theme.ColorThemeBackgroundHeader};
`

export const StyledDesktopMapContainer = styled.div`
  width: 100%;
  height: 100%;
  padding-bottom: ${pxToRems(50)};
  margin-top: ${pxToRems(-20)};
`

export const MapViewSearchControlsMobileWrapper = styled.div`
  background-color: #fff;
`
